// OrderSelect.js
// Component for Order Selector

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Button } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import dateFormat from 'dateformat';

// Component Class
// Shows Order Selector
class OrderSelect extends React.Component {
  // Returns the name for the given order
  getOrderName = (order) => {
    if (order == null)
      return "";
    if (order === this.props.orders.current)
      return "Pedido Aberto";

    var date = new Date(order.dateClosed);
    return dateFormat(date, "dd/mm/yyyy");
  }

  // Returns a list of orders
  getOrders = () => {
    var orders = this.props.orders.archive.slice();
    orders.push(this.props.orders.current);
    orders.reverse();
    return orders;
  }

  // Returns a filtered list of orders
  getFilteredOrders = () => {
    var orders = this.getOrders();
    if (!this.props.filter)
      return orders;

    var filtered = [];
    for (var i = 0; i < orders.length; i++) {
      if (this.filter(orders[i]))
        filtered.push(orders[i]);
    }
    return filtered;
  }

  // Returns a key for the given order
  getKey = (order) => {
    var orders = this.getOrders();
    for (var i = 0; i < orders.length; i++) {
      if (order === orders[i])
        return i;
    }
    return -1;
  }

  // Predicate for typeahead queries
  predicate = (query, order) => {
    var name = this.getOrderName(order);
    return name.toLowerCase().includes(query.toLowerCase());
  }

  // Renders an order item
  itemRenderer = (order, options) => {
    if (!options.modifiers.matchesPredicate) {
      return null;
    }

    return (
      <MenuItem
        active={options.modifiers.active}
        onClick={options.handleClick}
        key={this.getKey(order)}
        text={this.getOrderName(order)}
      />
    );
  };

  // Returns whether a given order belongs in the list
  filter = (order) => {
    if (!this.props.filter)
      return true;
    return this.props.filter(order);
  }

  // Renders Component
  render() {
    var orders = this.getFilteredOrders();
    var selected = this.props.selected;
    
    if (!selected || !this.filter(this.props.selected))
      selected = orders[0];

    return (
      <Select
        value={selected}
        items={orders}
        itemRenderer={this.itemRenderer}
        inputValueRenderer={this.getOrderName}
        itemPredicate={this.predicate}
        onItemSelect={this.props.setOrder}
        disabled={!selected}
      >
        <Button
          text={selected ? this.getOrderName(selected) : "Sem Pedidos"}
          disabled={!selected}
          rightIcon="double-caret-vertical"
          fill
        />
      </Select>
    );
  }
}

// Required Properties
OrderSelect.propTypes = {
  selected: PropTypes.object,
  filter: PropTypes.func,
  orders: PropTypes.object.isRequired,
  setOrder: PropTypes.func.isRequired,
}

// Exports
export default OrderSelect;


// WEBPACK FOOTER //
// ./src/components/ReportView/OrderSelect.js